import { IUEvent, IULocation } from '../../lib/event';
import ThanksgivingPhoto from '../../assets/promos/thanksgiving.png';
import { TAppAddress } from 'TProtocol/common/models';
import OktoberfestPhoto from '../../assets/promos/oktoberfest.png';
import HalloweenPartyPhoto from '../../assets/promos/halloweenParty.png';

export const SampleSeasonalEvents = [
  new IUEvent({
    photoUrl: OktoberfestPhoto,
    backgroundAnimationUrl: ' https://videos.pexels.com/video-files/3291693/3291693-sd_426_240_25fps.mp4',
    description: 'Come join us for a festive Oktoberfest filled with hearty German food, refreshing drinks, and lively entertainment! Enjoy bratwurst, pretzels, and more while soaking in the vibrant atmosphere. Bring your family and friends for fun games and music — don\'t miss this celebration of Bavarian culture and community!',
    title: 'Oktoberfest Celebration',
    startTime: 1759654800000,
    endTime: 1759770000000,
    location: new IULocation({
      displayName: 'Hotel Bavaria, Brehna, SA',
      address: new TAppAddress({
        address1: 'Hotel Bavaria, 6 Otto-Lilienthal-Straße',
        admin1: 'SA',
        city: 'Brehna',
        country: 'Germany',
        postalCode: '06796'
      })
    })
  }),
  new IUEvent({
    photoUrl: HalloweenPartyPhoto,
    backgroundAnimationUrl: 'https://videos.pexels.com/video-files/3189462/3189462-sd_426_240_24fps.mp4',
    description: 'You\'re invited to a spooktacular Halloween bash at our home! Join us for a night of eerie fun, delicious treats, and chilling drinks. Dress up in your best costume and get ready for games, music, and plenty of laughs. Bring your friends and family for a hauntingly good time — we can\'t wait to celebrate with you!',
    title: 'Spooky Soirée',
    startTime: 1761951600000,
    endTime: 1761966000000,
    location: new IULocation({
      displayName: '45 Stillwater Ave, Bangor, ME 04401',
      address: new TAppAddress({
        address1: '45 Stillwater Avenue',
        admin1: 'ME',
        city: 'Bangor',
        country: 'United States',
        postalCode: '04401'
      })
    })
  }),
  new IUEvent({
    photoUrl: ThanksgivingPhoto,
    backgroundAnimationUrl: 'https://videos.pexels.com/video-files/3198159/3198159-sd_426_240_25fps.mp4',
    description: 'Gather with us for a heartwarming Thanksgiving celebration, where we\'ll express gratitude and enjoy a bountiful feast. Expect a day filled with laughter, traditional Thanksgiving dishes, and the company of friends and family in a cozy, festive atmosphere.',
    title: 'Taylor Family Thanksgiving',
    startTime: 1757883600000,
    endTime: 0,
    location: new IULocation({
      displayName: 'Chileno Valley Ranch, Petaluma, CA',
      address: new TAppAddress({
        address1: 'Chileno Valley Ranch, 5105 Chileno Valley Road',
        admin1: 'CA',
        city: 'Petaluma',
        country: 'United States',
        postalCode: '94952'
      })
    })
  })
]
